import React from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {setSelectedHetPayAllowedToActions, setSelectedHetPayId} from '../../PortalsBlock/portalSlice';
import {validateAccountToIMEIService, closeModal, startPointEnum, saveDWHParams} from '../IMEIDeviceRepairSlice';
import {gtag4} from '../../../../utilities/analytics/tracking';

const CurrentOrgIdToSelectedAccount = (props) => {
  const setSelectedHetPayAndClose = () => {
    gtag4({
      event: 'DeviceRepair_OrganizationContinueButton',
      action: 'OrganizationContinueButton',
      button: 'אישור',
    });
    const selectedHetPay = props.portalState.selectedHetPay;
    props.setSelectedHetPayAllowedToActions(true);
    props.saveDWHParams({selectedHetPay});
    props.setSelectedHetPayId(selectedHetPay);
    props.closeModal();
    let sendingData = {
      orgId: props.selectedAccountOrgId,
      startPoint: props.deviceRepairData.startPoint,
      selectedNumber: props.deviceRepairData.selectedPhoneNumber,
      selectedIMEI: props.deviceRepairData.selectedIMEI,
      isPrivate: props.deviceRepairData?.isPrivate,
    };
    props.validateAccountToIMEIService(sendingData).then((res) => {
      if (!res.payload.error) {
        props.setCurrentStep(stepEnum.CAUSE_SELECTION);
      }
    });
  };

  const getText = () => {
    let text;
    if (props.deviceRepairData.startPoint == startPointEnum.PHONE) {
      text = `מנוי זה משוייך לארגון ${props.deviceRepairData.selectedAccountOrgName}`;
    } else {
      if (props.portalState.selectedHetPayId) {
        // text = `המנוי ${props.deviceRepairData.selectedPhoneNumber} המצומד לIMEI שבחרת אינו שייך לארגון ${props.portalState.selectedOrgName}`;
        text = `המנוי  המצומד לIMEI שבחרת אינו שייך לארגון ${props.portalState.selectedOrgName}`;
      } else {
        //text = `המנוי ${props.deviceRepairData.selectedPhoneNumber} המצומד לIMEI שבחרת שייך לארגון ${props.deviceRepairData.selectedAccountOrgName}`;
        text = `המנוי  המצומד לIMEI שבחרת שייך לארגון ${props.deviceRepairData.selectedAccountOrgName}`;
      }
    }
    return text;
  };

  const getSubText = () => {
    let subText;
    if (props.deviceRepairData.startPoint == startPointEnum.PHONE) {
      subText = `האם להמשיך?`;
    } else {
      if (props.portalState.selectedHetPayId) {
        subText = `הוא שייך לארגון ${props.deviceRepairData.selectedAccountOrgName}. </br> האם להמשיך?`;
      } else {
        subText = `האם להמשיך?`;
      }
    }
    return subText;
  };

  return (
    <div className='currentOrgIdToSelectedAccount-popup'>
      <div className='popup-image'>
        <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M61 20c-1.105 0-2-.927-2-2.071V12.07c0-1.144.895-2.071 2-2.071s2 .927 2 2.071v5.858C63 19.073 62.105 20 61 20zM94 54c0-1.105.927-2 2.071-2h5.858c1.144 0 2.071.895 2.071 2s-.927 2-2.071 2h-5.858C94.927 56 94 55.105 94 54zM17 54c0-1.105.927-2 2.071-2h5.858c1.144 0 2.071.895 2.071 2s-.927 2-2.071 2H19.07C17.927 56 17 55.105 17 54zM88.03 32a2.027 2.027 0 0 1-1.956-1.478 2.015 2.015 0 0 1 .909-2.271l4.914-2.944a2.036 2.036 0 0 1 2.047-.06 2.017 2.017 0 0 1 .045 3.52l-4.914 2.944c-.316.189-.677.289-1.045.289zM33.957 32c-.37 0-.733-.101-1.05-.291l-4.945-2.958a2.022 2.022 0 0 1-.67-2.768 2.048 2.048 0 0 1 2.774-.708l4.945 2.958c.786.47 1.16 1.404.914 2.282A2.039 2.039 0 0 1 33.957 32z'
            fill='var(--theme-primary, #810ea9)'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M79.946 34.345C74.918 29.077 68.011 25.8 60.451 25.8c-7.564 0-14.474 3.281-19.492 8.554-5.028 5.285-8.159 12.57-8.159 20.598 0 10.105 3.893 18.195 11.78 23.472v10.954c0 .638.452 1.237.97 1.715.392.407 1.028.562 1.775.57l26.9-2.239a2.54 2.54 0 0 0 1.577-.793c.373-.397.618-.919.618-1.5v-8.576c6.84-4.81 11.778-13.54 11.78-23.595-.047-8.036-3.207-15.328-8.254-20.615zm-36.064 3.29c4.239-4.49 10.112-7.263 16.569-7.263 6.45 0 12.317 2.766 16.568 7.249 4.21 4.441 6.83 10.569 6.83 17.331-.108 8.915-4.036 16.399-10.738 20.163-.32.179-.562.45-.733.76-.206.377-.31.811-.31 1.245v7.887l-23.234 1.934V77.12c0-.81-.293-1.592-.963-2.073-7.288-4.424-10.718-11.028-10.72-20.087-.05-6.758 2.54-12.882 6.73-17.324z'
            fill='#000'
          />
          <path
            d='M73.662 94.673a2.016 2.016 0 0 1 1.548.502c.426.382.693.94.72 1.563.06.693-.14 1.276-.505 1.718-.364.44-.89.743-1.48.802l-26.71 2.036c-.644-.012-1.206-.22-1.62-.591-.431-.385-.691-.935-.747-1.544-.054-.622.147-1.2.511-1.64.364-.44.89-.744 1.48-.803l26.803-2.043zM65.178 104.296a2.138 2.138 0 0 1 1.525.557c.403.369.66.897.687 1.504.059.694-.14 1.276-.506 1.718a2.218 2.218 0 0 1-1.489.803l-9.528.81c-.641-.014-1.2-.222-1.614-.591-.43-.386-.69-.935-.746-1.545-.054-.621.147-1.2.51-1.64a2.217 2.217 0 0 1 1.489-.803l9.672-.813zM64.496 40.325a2.134 2.134 0 0 1 1.764-.075c2.025.741 4.994 2.665 6.936 5.864 1.36 2.241 2.208 5.111 1.868 8.64a2.766 2.766 0 0 1-.83 1.704 2.337 2.337 0 0 1-1.564.66c-.758-.082-1.388-.414-1.813-.908a2.468 2.468 0 0 1-.576-1.872c.234-2.317-.314-4.113-1.136-5.482-1.488-2.476-3.907-3.542-4.41-3.726a2.566 2.566 0 0 1-1.353-1.337 2.833 2.833 0 0 1-.114-2.02 2.44 2.44 0 0 1 1.228-1.448z'
            fill='var(--theme-primary, #810ea9)'
          />
        </svg>
      </div>
      <div dangerouslySetInnerHTML={{__html: getText()}} className='popup-text' />
      <div dangerouslySetInnerHTML={{__html: getSubText()}} className='popup-subText' />
      <div>
        <BtnSubmit text={'אישור'} onclick={() => setSelectedHetPayAndClose()} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair, portalState: state.portalsBlock};
};

const mapDispatchToProps = {
  setSelectedHetPayAllowedToActions,
  setSelectedHetPayId,
  closeModal,
  validateAccountToIMEIService,
  saveDWHParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentOrgIdToSelectedAccount);
